export const DataTypes = ['dataType.decimal', 'dataType.integer', 'dataType.characters'];
export const DECIMAL_LENGTH = 4;
export default DataTypes;
